import React from 'react'
import Typography, { type TypographyProps } from '~/components/Typography'
import { cn } from '~/utils/cn'

export type HelperTextProps = TypographyProps<'p'> & {
  isError?: boolean
}

const HelperText = ({
  className,
  isError = false,
  ...restProps
}: HelperTextProps) => {
  return (
    <Typography
      color={isError ? 'error' : 'default'}
      className={cn(className, 'text-tiny')}
      {...restProps}
    />
  )
}

export default HelperText
